if (module.hot) {
  module.hot.accept();
}

// import { initCursor } from "./cursor";
import { initNav } from "./nav";
import { showSuccessMessage } from "./utils/helper";
import {
  validateEmail,
  validateFirstName,
  validateLastName,
  validateMessage,
} from "./utils/validate";

function init() {
  // initCursor();
  initNav();
}

window.addEventListener("load", function () {
  init();
});

const form = document.querySelector("#contactForm");
const submitButton = document.querySelector("#submitButton");
const firstName = document.querySelector("#fname");
const lastName = document.querySelector("#lname");
const email_address = document.querySelector("input#email");
const message = document.querySelector("#message");
const notes = document.querySelector("input#notes");

async function submitForm() {
  submitButton.disabled = true;

  const firstNameIsValid = validateFirstName(firstName.value);
  const lastNameIsValid = validateLastName(lastName.value);
  const emailIsValid = validateEmail(email_address.value);
  const messageIsValid = validateMessage(message.value);
  const notesIsValid = notes.value === "";
  const formData = new FormData(form);

  if (
    firstNameIsValid === false ||
    lastNameIsValid === false ||
    emailIsValid === false ||
    messageIsValid === false ||
    notesIsValid === false
  ) {
    console.log("failed");
    submitButton.disabled = false;

    return;
  }

  try {
    const response = await fetch("/", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams(formData).toString(),
    });
    if (response.ok) {
      showSuccessMessage("contact");
    }
  } catch (error) {
    console.error(error);
    return;
  }

  form.reset();
  submitButton.disabled = false;
}

//-----------EVENT LISTENERS----------------------

form.addEventListener("submit", function (e) {
  e.preventDefault();

  submitForm();
});

firstName.addEventListener("blur", function () {
  validateFirstName(firstName.value);
});

lastName.addEventListener("blur", function () {
  validateLastName(lastName.value);
});

email_address.addEventListener("blur", function () {
  validateEmail(email_address.value);
});

message.addEventListener("blur", function () {
  validateMessage(message.value);
});

//-----------FUNCTIONS----------------------

function displaySuccessMessage() {}
